import React from 'react';
import { Input, TextArea, Form, Dropdown, Checkbox, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import TagsBlock from '../TagsBlock';
import * as action from '../../../actions/newYouslim';
import { toastError } from '../../../utils/toastMessage';
import { defaultValue, defaultComplexity } from '../youslim2.0_Constants';

import {
  Content,
  TemplateNameBlock,
  ComplexityBlock,
  Label,
  LabelLength,
  TypeBlock,
  MainTitle,
  Message,
  Item,
  CheckboxWrapper,
  InputBlock,
  TimeContentBlock,
  AddButtonBlock,
  StyledLink,
  FooterBlock,
  ImageVideoBlock,
  FlexBlock,
  ToggleBlock,
  FirstBlock,
  ButtonBlock,
  UploadedVideo,
  Warning,
} from './CreateTrainingStyles';
import Navbar from '../Navigation/Navbar';

const CreateTraining = ({
  match,
  getTrainById,
  getComplexity,
  getTrainingType,
  getTrainingGears,
  complexity,
  updateTraining,
  trainingType,
  trainingGears,
  createTraining,
  currentTraining,
  isTrainingLoading,
  setCurrentTraining,
}) => {
  const [newTypeTrainingList, setNewTypeTrainingList] = React.useState([]);
  const [newComplexityList, setNewComplexityList] = React.useState([]);
  const [choosedTags, setChoosedTags] = React.useState(
    currentTraining && currentTraining.gears ? currentTraining.gears.map((tag) => tag.id) : [],
  );
  const [newName, setNewName] = React.useState(currentTraining ? currentTraining.title : '');
  const [newDescription, setNewDescription] = React.useState(
    currentTraining ? currentTraining.description : '',
  );
  const [typeTraining, setTypeTraining] = React.useState(
    currentTraining ? currentTraining.type_video_training_id : defaultValue,
  );
  const [trainingComplexity, setTrainingComplexity] = React.useState(
    currentTraining ? currentTraining.complexity_training_id : defaultComplexity,
  );
  const [videoLength, setVideoLength] = React.useState(
    currentTraining ? currentTraining.duration : 0,
  );
  const [uploadedPhoto, setUploadedPhoto] = React.useState(
    currentTraining ? currentTraining.preview : '',
  );
  const [uploadedVideo, setUploadedVideo] = React.useState(
    currentTraining ? currentTraining.video : '',
  );
  const [timestemp, setTimestemp] = React.useState(
    currentTraining && currentTraining.time_stamps ? currentTraining.time_stamps : [0],
  );
  const [isAddTraining, setIsAddTraining] = React.useState(true);
  const [requestDataForUpdate, setRequestDataForUpdate] = React.useState(false);
  const [isShowUpdatePopup, setIsShowUpdatePopup] = React.useState(false);
  const [isDraft, setIsDraft] = React.useState(currentTraining.is_draft);
  const [isVideosNotSelected, setIsVideosNotSelected] = React.useState(false);
  const [isPhotoNotSelected, setIsPhotoNotSelected] = React.useState(false);
  const [isDraftDisabled, setIsDraftDisabled] = React.useState(false);

  React.useEffect(() => {
    getComplexity();
    getTrainingType();
    getTrainingGears();
  }, []);

  React.useEffect(() => {
    if (!!currentTraining.title) {
      setNewName(currentTraining.title);
      setNewDescription(currentTraining.description);
      setTypeTraining(currentTraining.type_video_training.name);
      setTrainingComplexity(currentTraining.complexity_training.name);
      setVideoLength(currentTraining.duration);

      if (currentTraining && currentTraining.preview_file)
        setUploadedPhoto(currentTraining.preview_file);
      if (currentTraining.video_file && currentTraining.video_file.url)
        setUploadedVideo(currentTraining.video_file.url);
      if (currentTraining.video_file && currentTraining.video_file.time_stamps.length)
        setTimestemp(currentTraining.video_file.time_stamps);
      setChoosedTags(currentTraining.gears ? currentTraining.gears.map((tag) => tag.id) : []);
      setIsDraft(currentTraining.is_draft);
      setIsDraftDisabled(!currentTraining.is_draft);
    }
  }, [currentTraining]);

  React.useEffect(() => {
    const trainId = match && match.params && match.params.id;
    if (trainId) getTrainById(trainId);
    if (!trainId) onClear();
    return () => {
      setCurrentTraining({});
    };
  }, []);

  React.useEffect(() => {
    const newComplexityArray = complexity.map((item) => {
      return {
        id: item.id,
        key: item.id,
        value: item.name,
        text: item.name,
      };
    });
    setNewComplexityList(newComplexityArray);
  }, [complexity]);

  React.useEffect(() => {
    const newTrainingTypeArr = trainingType.map((item) => {
      return {
        id: item.id,
        key: item.id,
        value: item.name,
        text: item.name,
      };
    });
    setNewTypeTrainingList(newTrainingTypeArr);
  }, [trainingType]);

  const onClear = React.useCallback(() => {
    setNewName('');
    setNewDescription('');
    setUploadedPhoto('');
    setUploadedVideo('');
    setTimestemp([0]);
    setTrainingComplexity(defaultComplexity);
    setTypeTraining(defaultValue);
    setChoosedTags([]);
    setVideoLength(0);
    setIsDraft(true);
    document.getElementById('file-input').value = '';
    document.getElementById('video-input').value = '';
  }, [
    setNewName,
    setNewDescription,
    setVideoLength,
    setUploadedPhoto,
    setUploadedVideo,
    setTimestemp,
    setTrainingComplexity,
    setTypeTraining,
    setChoosedTags,
    setVideoLength,
    setIsDraft,
  ]);

  const onSave = React.useCallback(() => {
    if (!newName) {
      toastError('Название тренировки не заполнено');
      return;
    }
    if (!newDescription) {
      toastError('Введите описание тренировки');
      return;
    }
    if (!typeTraining) {
      toastError('Тип тренировки не выбран');
      return;
    }
    if (!trainingComplexity) {
      toastError('Сложность тренировки не выбрана');
      return;
    }
    if (!isDraft && !uploadedPhoto) {
      toastError('Изобажение не выбрано');
    }

    let currentTrainingType = 0;
    newTypeTrainingList.map((typeTrainings) => {
      if (typeTrainings.value === typeTraining) {
        currentTrainingType = typeTrainings.id;
      }
    });

    let currentComplexity = 0;
    newComplexityList.map((complexityItem) => {
      if (complexityItem.value === trainingComplexity) {
        currentComplexity = complexityItem.id;
      }
    });

    const training = {
      title: newName,
      description: newDescription,
      type_video_training_id: currentTrainingType,
      complexity_training_id: currentComplexity,
    };
    if (videoLength) training.duration = videoLength;
    if (uploadedPhoto) training.preview = uploadedPhoto;
    if (uploadedVideo) training.video = uploadedVideo;
    if (timestemp && uploadedVideo) training.time_stamps = timestemp;
    if (choosedTags) training.gears = choosedTags;

    if (currentTraining.id) {
      training.is_draft = isDraft;
      updateTraining(training, currentTraining.id);
    } else {
      createTraining(training, onClear);
    }
  });

  const onAddNewStep = React.useCallback(() => {
    setTimestemp([...timestemp, '']);
  }, [timestemp, setTimestemp]);

  const onRemoveStep = React.useCallback(
    (index) => {
      const newTimestemp = [...timestemp];
      newTimestemp.splice(index, 1);
      setTimestemp([...newTimestemp]);
    },
    [timestemp, setTimestemp],
  );

  const onChangeStep = (index, value) => {
    timestemp[index] = value;
    setIsAddTraining(!isAddTraining);
  };

  const handleUploadPhoto = React.useCallback(
    (e) => {
      const file = e.target.files[0];
      setUploadedPhoto(file);
    },
    [setUploadedPhoto],
  );

  const handleUploadVideo = React.useCallback(
    (e) => {
      const video = e.target.files[0];
      setUploadedVideo(video);
    },
    [setUploadedVideo],
  );

  const selectTraining = (data) => {
    setTypeTraining(data.value);
  };

  const selectComplexity = (data) => {
    setTrainingComplexity(data.value);
  };

  const handleKeypress = (e) => {
    const characterCode = e.key;
    if (characterCode === 'Backspace') return;
    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const onChangeDuration = (value) => {
    if (value > 100) {
      setVideoLength(100);
    } else {
      setVideoLength(value);
    }
  };
  const onChangeTimestemp = (index, value) => {
    const newTimestemp = timestemp;
    if (value > 6000) {
      newTimestemp[index] = 6000;
      setTimestemp([...newTimestemp]);
    } else {
      newTimestemp[index] = value;
      setTimestemp([...newTimestemp]);
    }
    setIsAddTraining(!isAddTraining);
  };

  const onHandleUpdate = React.useCallback(() => {
    updateTraining(requestDataForUpdate, currentTraining.id);
  }, [requestDataForUpdate, currentTraining, updateTraining]);

  return (
    <React.Fragment>
      <Navbar />
      <Content>
        <MainTitle>
          {currentTraining.id ? 'Редактирование тренировки' : 'Создание тренировки'}
        </MainTitle>
        <Warning>
          {currentTraining.id &&
            'Внимание! При переводе в статус "Опубликовано" все поля должны быть заполнены!'}
        </Warning>
        <TemplateNameBlock>
          <FirstBlock>
            <ToggleBlock>
              <Label>
                Название тренировки<Message>*</Message>
              </Label>
              <Checkbox
                toggle
                label="Черновик"
                value={isDraft}
                checked={isDraft}
                defaultChecked={currentTraining.id ? isDraft : true}
                // disabled={currentTraining ? !isDraft : isDraft}
                disabled={currentTraining.id ? !isDraft : isDraft}
                onChange={() => setIsDraft(!isDraft)}
              />
            </ToggleBlock>
            <Input
              type="text"
              placeholder="Введите название тренировки"
              className="template-name-input"
              value={newName}
              onChange={(event) => setNewName(event.target.value)}
            />
          </FirstBlock>
          <FirstBlock>
            <Label>
              Описание тренировки<Message>*</Message>
            </Label>
            <Form className="template-description-input">
              <Form.Field
                control={TextArea}
                placeholder="Введите описание тренировки"
                value={newDescription}
                onChange={(event) => setNewDescription(event.target.value)}
                rows={3}
              />
            </Form>
          </FirstBlock>
        </TemplateNameBlock>
        <TypeBlock>
          <ComplexityBlock>
            <Label>
              Тип тренировки<Message>*</Message>
            </Label>
            <Item>
              <Dropdown
                openOnFocus
                selection
                options={newTypeTrainingList}
                placeholder="Тип тренировки"
                value={typeTraining}
                onChange={(e, data) => selectTraining(data)}
              />
            </Item>
          </ComplexityBlock>
          <ComplexityBlock>
            <Label>
              Сложность<Message>*</Message>
            </Label>
            <Item>
              <Dropdown
                placeholder="сложность"
                openOnFocus
                selection
                options={newComplexityList}
                value={trainingComplexity}
                onChange={(e, data) => selectComplexity(data)}
              />
            </Item>
          </ComplexityBlock>
          <ComplexityBlock>
            <LabelLength>Длительность(мин)</LabelLength>
            <Input
              id="myInput"
              type="number"
              max="100"
              min="0"
              onKeyDown={handleKeypress}
              placeholder="в минутах"
              value={videoLength}
              onChange={(e) => onChangeDuration(e.target.value)}
              style={{ width: '100px' }}
            />
          </ComplexityBlock>
        </TypeBlock>

        <Form.Field error={isVideosNotSelected}>
          <div>
            {uploadedVideo && uploadedVideo.name !== '' && (
              <UploadedVideo>{`Загружено видео: ${
                uploadedVideo.name ? uploadedVideo.name : uploadedVideo
              }, загрузить другое?`}</UploadedVideo>
            )}
          </div>
        </Form.Field>
        <Form.Field error={isPhotoNotSelected}>
          <div>
            {uploadedPhoto && uploadedPhoto.url !== '' && (
              <UploadedVideo>{`Загружено изображение: ${
                uploadedPhoto.url ? uploadedPhoto.url : uploadedPhoto
              }, загрузить другое?`}</UploadedVideo>
            )}
          </div>
        </Form.Field>
        <InputBlock>
          <ImageVideoBlock>
            <Label>Изображение</Label>
            <Input
              id="file-input"
              type="file"
              title="Изображение"
              accept="image/png, image/jpeg, image/jpg"
              onChange={handleUploadPhoto}
            />
          </ImageVideoBlock>

          <ImageVideoBlock>
            <Label>Видео</Label>
            <Input type="file" id="video-input" accept="video/*" onChange={handleUploadVideo} />
          </ImageVideoBlock>
        </InputBlock>
        <FlexBlock>
          {timestemp.map((time, index) => {
            return (
              <TimeContentBlock>
                <ImageVideoBlock>
                  <Label style={{ marginLeft: '-20px' }}>Таймстемп(сек) </Label>
                  <Input
                    type="number"
                    id="timestamp"
                    placeholder="сек"
                    style={{ width: '100px', minHeight: '40px', marginLeft: '-20px' }}
                    defaultValue={timestemp[index]}
                    onKeyDown={handleKeypress}
                    value={time}
                    onChange={(e) => onChangeTimestemp(index, e.target.value)}
                    min="0"
                    max="6000"
                  />
                  <AddButtonBlock>
                    <Button positive onClick={onAddNewStep} style={{ marginBottom: '5px' }}>
                      +
                    </Button>
                    {index > 0 && (
                      <Button negative onClick={() => onRemoveStep(index)}>
                        -
                      </Button>
                    )}
                  </AddButtonBlock>
                </ImageVideoBlock>
              </TimeContentBlock>
            );
          })}
        </FlexBlock>

        <CheckboxWrapper>
          <Label>Инвентарь</Label>
          <TagsBlock
            allTags={trainingGears}
            choosedTags={choosedTags}
            setChoosedTags={setChoosedTags}
            width="100%"
          />
        </CheckboxWrapper>
        <ButtonBlock>
          <Button positive onClick={onSave} loading={isTrainingLoading}>
            {currentTraining.id ? 'Обновить' : 'Сохранить'}
          </Button>
          <Button onClick={onClear}>Очистить</Button>
        </ButtonBlock>
      </Content>
      <FooterBlock />
      `;
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const {
    complexity,
    trainingType,
    trainingGears,
    isTrainingLoading,
    currentTraining,
  } = state.newYouslim;
  return {
    complexity,
    trainingType,
    trainingGears,
    isTrainingLoading,
    currentTraining,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getComplexity: () => {
      dispatch(action.getComplexity());
    },
    getTrainingType: () => {
      dispatch(action.getTrainingType());
    },
    getTrainingGears: () => {
      dispatch(action.getTrainingGears());
    },
    createTraining: (data, clear) => {
      dispatch(action.createTraining(data, clear));
    },
    setCurrentTraining: (training) => {
      dispatch(action.setCurrentTraining(training));
    },
    getTrainById: (id) => {
      dispatch(action.getTrainById(id));
    },
    updateTraining: (data, id) => {
      dispatch(action.updateTraining(data, id));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateTraining);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateTraining/index.jsx